import { memo } from "react";
import CloseIcon from "@/assets/icons/close-thin.svg";

interface Props {
  title?: string;
  description?: string;
  image?: string;
  link: string;
  onRemove: (link: string) => void;
}

const FeedOgData = ({ image, title, description, link, onRemove }: Props) => {
  return (
    <div className="flex gap-2 mb-4 relative w-full">
      {image && (
        <img
          className="object-cover"
          src={image}
          alt={title || ""}
          width={100}
          height={100}
        />
      )}
      <div className="flex flex-col">
        <span className="font-bold text-sm text-ellipsis">{title}</span>
        <span className="text-sm text-ellipsis text-body-4">{description}</span>
      </div>
      <div
        className="flex flex-col justify-start cursor-pointer absolute top-0 right-0"
        onClick={() => onRemove(link)}
      >
        <CloseIcon className="w-3 fill-primary" />
      </div>
    </div>
  );
};

export default memo(FeedOgData);
